import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"margin-top":"-50px"}
}
const _hoisted_2 = { class: "col-12 col-lg-8 offset-lg-2" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = { class: "card-header pt-7 d-flex flex-row align-items-start flex-nowrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left fs-2 pe-4 p-1" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "card-label fw-bolder fs-1" }
const _hoisted_9 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = { class: "card-body pt-4 pt-md-6" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "d-flex align-items-center w-100 mb-8" }
const _hoisted_14 = { class: "progress h-8px w-100 me-2 bg-light-primary" }
const _hoisted_15 = ["aria-valuenow"]
const _hoisted_16 = { class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-image fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Upload a logo</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">upload a photo or logo to allow people to easily identify your production in StageHub</span></div></div>", 1)
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-buildings fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Add Rehearsal &amp; Performance Spaces</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">add venues with one or more spaces, to be used when scheduling calls</span></div></div>", 1)
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-calendar-star fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Customize Call Types</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">color-code your calendar with different call types</span></div></div>", 1)
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-people-group fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Create Groups</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">create &amp; add people to custom groups, to make scheduling and sending communications way easier </span></div></div>", 1)
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-users fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Invite People</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">invite other managers, and regular members to your production</span></div></div>", 1)
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "d-flex",
  style: {"justify-content":"center"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-party-horn text-primary fa-4x" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Return To Main Screen", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-primary text-hover-white" }, "Go To Dashboard", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Go To Dashboard", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "d-flex flex-column align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_VenueSettings = _resolveComponent("VenueSettings")!
  const _component_CallTypeSettings = _resolveComponent("CallTypeSettings")!
  const _component_GroupSettings = _resolveComponent("GroupSettings")!
  const _component_PeopleSettings = _resolveComponent("PeopleSettings")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.subStep !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-block d-md-none cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToChecklist && _ctx.backToChecklist(...args)))
              }, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.headerTitle), 1),
            (_ctx.subStep === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.headerSubtitle), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.$route.query.fromFlow && _ctx.subStep === 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "secondary",
                  class: "d-none d-md-block me-4 btn-sm",
                  onClick: _ctx.returnToOnboardHome
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("go back ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep !== 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  type: "secondary",
                  class: "d-none d-md-block me-4 btn-sm",
                  onClick: _ctx.backToChecklist
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("back to checklist ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.$route.query.fromFlow && _ctx.subStep === 0 && !_ctx.completed)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  type: "secondary",
                  class: "d-none d-md-block me-4 btn-sm",
                  onClick: _ctx.skip
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("skip for now ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep === 1)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  onClick: _ctx.addVenue,
                  class: "d-none d-md-block btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add venue")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep === 2)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  onClick: _ctx.addCallType,
                  class: "d-none d-md-block btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add call type")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep === 3)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 5,
                  onClick: _ctx.addGroup,
                  class: "d-none d-md-block btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add group")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep === 4)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 6,
                  onClick: _ctx.addPeople,
                  class: "d-none d-md-block btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("invite people")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.subStep === 0 && !_ctx.completed)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      role: "progressbar",
                      style: _normalizeStyle(`width: ${_ctx.progress}%`),
                      "aria-valuenow": _ctx.progress,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, _hoisted_15)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.onboardStatus.photo === '' || _ctx.onboardStatus.photo === null)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                          key: 0,
                          class: "avatar-uploader",
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          "http-request": _ctx.requestCropper
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              type: "primary",
                              class: "btn-icon btn-sm"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["on-success", "before-upload", "http-request"])), [
                          [_directive_loading, _ctx.photoIsLoading]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                  ])), [
                    [_directive_loading, _ctx.photoIsLoading]
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.subStep = 1)),
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    (!_ctx.onboardStatus.hasVenues)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.subStep = 1))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.subStep = 2)),
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    (!_ctx.onboardStatus.hasCallTypes)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.subStep = 2))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.subStep = 3)),
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
                }, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    (!_ctx.onboardStatus.hasGroups)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.subStep = 3))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.subStep = 4)),
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer"
                }, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    (!_ctx.onboardStatus.hasPeople)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.onboardingIsLoading]
              ])
            : _createCommentVNode("", true),
          (_ctx.subStep === 0 && _ctx.completed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createVNode(_component_el_empty, { description: "Nice! You've finished setting up your production." }, {
                  image: _withCtx(() => [
                    _hoisted_48
                  ]),
                  default: _withCtx(() => [
                    (_ctx.isFromFlow)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "btn btn-primary d-flex flex-column flex-center mt-4",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goToProduction && _ctx.goToProduction(...args)))
                        }, _hoisted_50))
                      : _createCommentVNode("", true),
                    (_ctx.isFromFlow)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "btn-link btn link-primary text-primary d-flex flex-column flex-center",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)))
                        }, _hoisted_52))
                      : _createCommentVNode("", true),
                    (!_ctx.isFromFlow)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "btn btn-primary text-primary d-flex flex-column flex-center",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToProduction && _ctx.goToProduction(...args)))
                        }, _hoisted_54))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.subStep === 1)
            ? (_openBlock(), _createBlock(_component_VenueSettings, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.subStep === 2)
            ? (_openBlock(), _createBlock(_component_CallTypeSettings, { key: 3 }))
            : _createCommentVNode("", true),
          (_ctx.subStep === 3)
            ? (_openBlock(), _createBlock(_component_GroupSettings, { key: 4 }))
            : _createCommentVNode("", true),
          (_ctx.subStep === 4)
            ? (_openBlock(), _createBlock(_component_PeopleSettings, { key: 5 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_55, [
            (_ctx.subStep === 0 && !_ctx.completed)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "secondary",
                  class: "d-block d-md-none mb-4",
                  onClick: _ctx.skip
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("skip for now ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}